import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import ProductCategory from '../views/master/ProductCategory.vue'
import StichingCategory from '../views/master/StichingCategory.vue'
import AddProduct from '../views/product/AddProduct.vue'
import ListProduct from '../views/product/ListProduct.vue'
import Barcode from '../views/product/Barcode.vue'
import Vendors from '../views/master/Vendors.vue'
import Customer from '../views/master/Customer.vue'
import SaleView from '../views/sale/SaleView.vue'
import SaleList from '../views/sale/SaleList.vue'
import print from '../views/sale/print.vue'
import thermalPrint from '../views/sale/thermalPrint.vue'
import printReceipt from '../views/sale/printReceipt.vue'
import PurchaseView from '../views/purchase/PurchaseView.vue'
import PurchaseList from '../views/purchase/PurchaseList.vue'
import delievryReport from '../views/report/delievryReport.vue'
import itemReport from '../views/report/itemReport.vue'
import accountReport from '../views/accounting/accountReport.vue'
import StichingMeasurment from '../views/master/StichingMeasurment.vue'
import measurementprint from '../views/sale/measurementprint.vue'
import MeasurementList from '../views/measurementlist/MeasurementList.vue'
import MeasurementDetails from '../views/measurementlist/MeasurementDetails.vue'
import allmeasurement from '../views/measurementlist/allmeasurement.vue'
import TailorHomeView from '../views/TailorHomeView.vue'
import customerhistory from '../views/master/customerhistory.vue'
import settings from '../views/setting/settings.vue'
import A4 from '../views/sale/A4.vue'
import singlemeasurement from '../views/sale/singlemeasurement.vue'
import Employee from '../views/master/Employee.vue'
import salaryReport from '../views/report/salaryReport.vue'
import emphistory from '../views/master/emphistory.vue'
import ordertakenlist from '../views/measurementlist/ordertakenlist.vue'
import measurementview from '../views/measuremment_new/measurementview.vue'
import totalmeasurementlist from '../views/measuremment_new/totalmeasurementlist.vue'
import new_measurement_print from '../views/measuremment_new/new_measurement_print.vue'










const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: HomeView
  },
  {
    path: '/Barcode',
    name: 'Barcode',
    component: Barcode
  },
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/printReceipt',
    name: 'printReceipt',
    component: printReceipt
  },
  {
    path: '/thermalPrint',
    name: 'thermalPrint',
    component: thermalPrint
  },
  {
    path: '/productcategory',
    name: 'productcategory',
    component: ProductCategory
  },
  {
    path: '/stichingcategory',
    name: 'stichingcategory',
    component: StichingCategory
  },
  {
    path: '/accountReport',
    name: 'accountReport',
    component: accountReport
  },

  {
    path: '/StichingMeasurment',
    name: 'StichingMeasurment',
    component: StichingMeasurment
  },




  {
    path: '/print',
    name: 'print',
    component: print
  },
  {
    path: '/addproduct',
    name: 'addproduct',
    component: AddProduct
  },
  {
    path: '/listproduct',
    name: 'listproduct',
    component: ListProduct
  },
  {
    path: '/vendors',
    name: 'vendors',
    component: Vendors
  },
  {
    path: '/customer',
    name: 'customer',
    component: Customer
  },
  {
    path: '/saleview',
    name: 'saleview',
    component: SaleView
  },
  {
    path: '/salelist',
    name: 'salelist',
    component: SaleList
  },
  {
    path: '/purchaseview',
    name: 'purchaseview',
    component: PurchaseView
  },

  {
    path: '/purchaselist',
    name: 'purchaselist',
    component: PurchaseList
  },


  {
    path: '/delievryReport',
    name: 'delievryReport',
    component: delievryReport
  },

  {
    path: '/itemReport',
    name: 'itemReport',
    component: itemReport
  },

  {
    path: '/measurementprint',
    name: 'measurementprint',
    component: measurementprint
  },


   {
    path: '/MeasurementList',
    name: 'MeasurementList',
    component: MeasurementList
  },
  {
    path: '/MeasurementDetails',
    name: 'MeasurementDetails',
    component: MeasurementDetails
  },

  {
    path: '/allmeasurement',
    name: 'allmeasurement',
    component: allmeasurement
  },
    {
    path: '/TailorHomeView',
    name: 'TailorHomeView',
    component: TailorHomeView
  },


    {
    path: '/customerhistory',
    name: 'customerhistory',
    component: customerhistory
  },
   {
    path: '/settings',
    name: 'settings',
    component: settings
  },

  {
    path: '/A4',
    name: 'A4',
    component: A4
  },
    {
    path: '/singlemeasurement',
    name: 'singlemeasurement',
    component: singlemeasurement
  },

   {
    path: '/Employee',
    name: 'Employee',
    component: Employee 
  },
   {
    path: '/salaryReport',
    name: 'salaryReport',
    component: salaryReport 
  },

   {
    path: '/emphistory',
    name: 'emphistory',
    component: emphistory 
  },
  {
    path: '/ordertakenlist',
    name: 'ordertakenlist',
    component: ordertakenlist 
  },
 {
    path: '/measurementview',
    name: 'measurementview',
    component: measurementview 
  },

  {
    path: '/totalmeasurementlist',
    name: 'totalmeasurementlist',
    component: totalmeasurementlist 
  },

  
  {
    path: '/new_measurement_print',
    name: 'new_measurement_print',
    component: new_measurement_print 
  },





  
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
